var map = {
	"./editorBaseApi": [
		44484
	],
	"./editorBaseApi.js": [
		44484
	],
	"./editorSimpleWorker": [
		9148
	],
	"./editorSimpleWorker.js": [
		9148
	],
	"./editorWorker": [
		56913
	],
	"./editorWorker.js": [
		56913
	],
	"./editorWorkerHost": [
		27551
	],
	"./editorWorkerHost.js": [
		27551
	],
	"./findSectionHeaders": [
		79866
	],
	"./findSectionHeaders.js": [
		79866
	],
	"./getIconClasses": [
		25977
	],
	"./getIconClasses.js": [
		25977
	],
	"./languageFeatureDebounce": [
		57747
	],
	"./languageFeatureDebounce.js": [
		57747
	],
	"./languageFeatures": [
		35595
	],
	"./languageFeatures.js": [
		35595
	],
	"./languageFeaturesService": [
		84357
	],
	"./languageFeaturesService.js": [
		84357
	],
	"./languageService": [
		84049
	],
	"./languageService.js": [
		84049
	],
	"./languagesAssociations": [
		7203
	],
	"./languagesAssociations.js": [
		7203
	],
	"./languagesRegistry": [
		7796
	],
	"./languagesRegistry.js": [
		7796
	],
	"./markerDecorations": [
		45201
	],
	"./markerDecorations.js": [
		45201
	],
	"./markerDecorationsService": [
		63918
	],
	"./markerDecorationsService.js": [
		63918
	],
	"./model": [
		55349
	],
	"./model.js": [
		55349
	],
	"./modelService": [
		41058
	],
	"./modelService.js": [
		41058
	],
	"./resolverService": [
		10785
	],
	"./resolverService.js": [
		10785
	],
	"./semanticTokensDto": [
		69895
	],
	"./semanticTokensDto.js": [
		69895
	],
	"./semanticTokensProviderStyling": [
		81197
	],
	"./semanticTokensProviderStyling.js": [
		81197
	],
	"./semanticTokensStyling": [
		94496
	],
	"./semanticTokensStyling.js": [
		94496
	],
	"./semanticTokensStylingService": [
		36137
	],
	"./semanticTokensStylingService.js": [
		36137
	],
	"./textModelSync/textModelSync.impl": [
		2296
	],
	"./textModelSync/textModelSync.impl.js": [
		2296
	],
	"./textModelSync/textModelSync.protocol": [
		38797,
		797
	],
	"./textModelSync/textModelSync.protocol.js": [
		38797,
		797
	],
	"./textResourceConfiguration": [
		10043
	],
	"./textResourceConfiguration.js": [
		10043
	],
	"./treeSitterParserService": [
		44227
	],
	"./treeSitterParserService.js": [
		44227
	],
	"./treeViewsDnd": [
		98230
	],
	"./treeViewsDnd.js": [
		98230
	],
	"./treeViewsDndService": [
		82235
	],
	"./treeViewsDndService.js": [
		82235
	],
	"./unicodeTextModelHighlighter": [
		89168
	],
	"./unicodeTextModelHighlighter.js": [
		89168
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 59135;
module.exports = webpackAsyncContext;